import { supportVersion } from '@utils/tools';
import { useCallback, useEffect } from 'react';
import { useTranslate } from './useTranslate';
import bridge from '@bridge/imlv';

export function useSupportVersionToast(judgeStr: string, starlingKey: string) {
  const translate = useTranslate();
  const fn = useCallback(async () => {
    const isSupport = await supportVersion(judgeStr);
    const text = translate(starlingKey);
    // 表示版本过低，并且翻译文案已ready
    if (!isSupport && starlingKey !== text) {
      bridge.view.toast({
        text,
      });
    }
  }, [translate]);
  useEffect(() => {
    fn();
  }, [fn]);
}
